import * as Yup from 'yup';

import { FORM_CONSTANTS, FORM_MESSAGES } from '../../../commonConstants';

export const CandidateQuestionFormSchema = Yup.object().shape({
  current_employer: Yup.string()
    .min(FORM_CONSTANTS.MIN_LENGTH, FORM_MESSAGES.TOO_SHORT)
    .max(FORM_CONSTANTS.MAX_LENGTH, FORM_MESSAGES.TOO_LONG),
  current_location: Yup.string()
    .min(FORM_CONSTANTS.MIN_LENGTH, FORM_MESSAGES.TOO_SHORT)
    .max(FORM_CONSTANTS.MAX_LENGTH, FORM_MESSAGES.TOO_LONG),
  current_title: Yup.string()
    .min(FORM_CONSTANTS.MIN_LENGTH, FORM_MESSAGES.TOO_SHORT)
    .max(FORM_CONSTANTS.MAX_LENGTH, FORM_MESSAGES.TOO_LONG),
});

export const INITIAL_VALUES = {
  current_employer: '',
  current_location: '',
  current_title: '',
  diversity_hire: false,
  joining_date: '',
  candidate_skills: [],
  links_json: [{ type: 'pw', value: '' }],
  files: [],
  license_available: '',
};
